/**
 * Attendance on a Curs FPED cohort, in words (13.10.2026). The server counts
 * (`services/portal/simple_attendance.py`); this says what the numbers mean.
 */
export const STATES = [
  { value: "present", label: "Prezent" },
  { value: "absent", label: "Absent" },
  { value: "recovered", label: "Recuperat" },
];

const MONTHS = ["ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec."];
const DAYS = ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];

/** `2026-09-08` → `marți, 8 sept.` */
export function dayText(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
  if (!m) return "";
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12);
  return `${DAYS[d.getDay()]}, ${Number(m[3])} ${MONTHS[Number(m[2]) - 1]}`;
}

/** 180 → "3 h", 90 → "1,5 h", 0 → "0 h". */
export function hoursText(minutes) {
  const h = Math.round((Number(minutes) || 0) / 6) / 10;
  return `${String(h).replace(".", ",")} h`;
}

/** The chip on a session's row. */
export function sessionState(session) {
  if (session.marked) {
    const c = session.counts || {};
    const parts = [`${c.present || 0} ${c.present === 1 ? "prezent" : "prezenți"}`];
    if (c.recovered) parts.push(`${c.recovered} ${c.recovered === 1 ? "recuperat" : "recuperați"}`);
    if (c.absent) parts.push(`${c.absent} ${c.absent === 1 ? "absent" : "absenți"}`);
    return { tone: "good", text: parts.join(" · ") };
  }
  if (session.started) return { tone: "warn", text: "nemarcată" };
  return { tone: "neutral", text: "urmează" };
}

/** What to say next to a participant's hours: nothing while it is still open. */
export function standing(person, complete) {
  if (person.meets) return { tone: "good", text: "are 80%" };
  if (person.out_of_reach) return { tone: "late", text: "nu mai poate ajunge la 80%" };
  if (complete) return { tone: "late", text: "sub 80%" };
  return null;
}

/** The marks an editor opens with: what was saved, or everybody present —
 *  marking the few who were away is quicker than ticking everyone who came. */
export function startingMarks(session, participants) {
  const out = {};
  (participants || []).forEach((p) => {
    out[p.enrollment_id] = (session.marked && session.marks?.[p.enrollment_id]) || (session.marked ? "absent" : "present");
  });
  return out;
}

/** "3 din 5 sesiuni marcate · pragul: 12 din 15 h (80%)". */
export function summaryLine(data) {
  const n = data?.sessions?.length || 0;
  if (!n) return "Grupa nu are încă sesiuni în program.";
  return `${data.marked_sessions} din ${n} sesiuni marcate · pragul: ${hoursText(data.needed_minutes)} din `
    + `${hoursText(data.total_minutes)} (${data.threshold_percent}%)`;
}
